/* eslint-disable import/no-anonymous-default-export */

import secureLocalStorage from "react-secure-storage";

// eslint-disable-next-line import/no-anonymous-default-export
const initialState =
  JSON.parse(secureLocalStorage.getItem("mode"))?.mode || "light";

export default (state = initialState, action) => {
  switch (action.type) {
    case "GET_MODE":
      return action.payload;

    case "SET_MODE":
      return action.payload;

    default:
      return state;
  }
};
